import {OrderProductCreateDto, ProductDto} from "../../../api";
import OrderProductModalForm, {ProductPreviewImage} from "../orderProductModalForm/orderProductModalForm";

export default function OrderProductModalFormAddContainer(props: OrderProductModalFormAddContainerProps) {
    return <OrderProductModalForm
        products={props.products}
        productImage={props.productImage}
        isModalVisible={props.addFormVisibility}
        setModalVisibility={props.onFinish}
        onSubmit={props.onSubmit}
        modalTitle={props.title}
        saveButtonTitle="Zapisz"
    />;
}

interface OrderProductModalFormAddContainerProps {
    onFinish: (refreshList: boolean) => void,
    onSubmit: (values: OrderProductCreateDto) => Promise<any>,
    addFormVisibility: boolean,
    title: string,
    products: ProductDto[],
    productImage: ProductPreviewImage[];
}
